<template>
  <transition
    :css="animation.css"
    :name="animation.name"
    :mode="animation.mode"
    @enter="animation.css ? null : animation.enter"
    @leave="animation.css ? null : animation.leave"
  >
    <div
      v-if="show"
      class="c-template c-template--cookie"
      :data-theme="theme"
    >
      <slot
        v-for="slot in slots"
        :name="slot"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
    animation: {
      type: Object,
      required: false,
      default() {
        return {
          css: false,
          name: '',
          mode: 'in-out',
          enter: (element, done) => { done(); },
          leave: (element, done) => { done(); },
        };
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },
};
</script>

<style lang="scss" scoped>
.c-template.c-template--cookie {
  box-sizing: border-box;
  position: fixed;
  width: 100%;

  &[data-theme="default"] {
    font-family: 'GT America', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 16px;
    bottom: 0px;
    left: 0px;
    background-color:$color-dark;
    padding: 15px 45px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
